import React, { Component } from "react";
import {
    Row,
    Col,
    FormGroup,
    ControlLabel,
    FormControl,
    Alert
} from "react-bootstrap";

// Components
import { Card } from "components/Card/Card.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import { areaSelectOptionRequest } from "api/area";
import { createPayLevelRequest } from "api/payLevel";
import { editPayLevelRequest } from "api/payLevel";
import { fetchPayLevelRequest } from "api/payLevel";

class PayLevelForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
          resource: {
            payLevelName: '',
            area: '',
            sickLeaveDays: 0,
            vacationLeaveDays: 0,
          },
          areaSelectOptions: [],
          error: null
        }
    };
    componentDidMount() {
        const { instanceId } = this.props;
    
        if (instanceId) {
          this.fetchInstance(instanceId);
        }
    
        areaSelectOptionRequest(
          result => this.setState({ areaSelectOptions: result }),
          error => this.setState({ error: "There was an error" })
        );
    }

    fetchInstance = (id) => {
        fetchPayLevelRequest(id,
            result => this.setState(prevState => ({
                resource: {
                    ...prevState.resource,
                    ...result
                }
            })), error => this.setState({ error: 'There was an error' }));
    }
    

    handleFormChange = (e) => {
        const { target } = e;
        const { name, value } = target;
    
        this.setState(prevState => ({
          resource: {
            ...prevState.resource,
            [name]: value,
          },
        }))
    }

    save = () => {
        const {
          payLevelName,
          area,
          sickLeaveDays,
          vacationLeaveDays
        } = this.state.resource;
        

        const {
          instanceId
        } = this.props;
    
        const isNewRecord = !instanceId;
    
        let data = {
            payLevelName,
            area,
            sickLeaveDays: Number(sickLeaveDays),
            vacationLeaveDays: Number(vacationLeaveDays)
        };
    
        if (isNewRecord) {
            createPayLevelRequest(data,
                result => this.saveSuccess(),
                error => this.saveFailure(error)
            );
        } else {
            editPayLevelRequest(instanceId, data,
                result => this.saveSuccess(),
                error => this.saveFailure(error)
            );
        }
      }

      saveSuccess = (result) => {
        this.setState({ error: null });
        this.props.goToList('pay-level');
      }
    
      saveFailure = (error) => {
        this.setState({ error: error.message || 'There was an error saving pay level.' })
      }

    render () {
        const {
            error,
            areaSelectOptions
        } = this.state;

        const {
            payLevelName,
            area,
            sickLeaveDays,
            vacationLeaveDays
          } = this.state.resource;

        const {
            instanceId,
        } = this.props;
      
        const isNewRecord = !instanceId;

        return (
            <Row>
                <Col md={12}>
                    <Card
                        title={isNewRecord ? "New entry" : "Edit entry"}
                        content={
                        <form>
                            <Button className="card-top-btn btn-primary" onClick={() => this.props.goToList('pay-level')}>
                                Back to List
                            </Button>
                            <FormGroup>
                                <ControlLabel>Pay Level Name <span className="required-star">*</span></ControlLabel>
                                <FormControl
                                    type="text"
                                    name="payLevelName"
                                    value={payLevelName}
                                    onChange={this.handleFormChange}
                                    placeholder=""
                                />
                            </FormGroup>
                            <FormGroup>
                                <ControlLabel>Area <span className="required-star">*</span></ControlLabel>
                                <FormControl 
                                    onChange={this.handleFormChange}
                                    componentClass="select" 
                                    name="area"
                                    value={area && area._id ? area._id : area}
                                >
                                    <option value="">Select</option>
                                        {areaSelectOptions.map(option => {
                                            return (
                                            <option
                                                key={option.value}
                                                value={option.value}
                                            >
                                                {option.label}
                                            </option>
                                            );
                                        })}
                                </FormControl>
                            </FormGroup>
                            <Row>
                                <Col md={6}>
                                    <FormGroup>
                                        <ControlLabel>
                                            Annual Sick Leave
                                            <span className="required-star">*</span>
                                        </ControlLabel>
                                        <FormControl
                                            type="number"
                                            name="sickLeaveDays"
                                            value={sickLeaveDays}
                                            onChange={this.handleFormChange}
                                            min="0"
                                            step="1"
                                        />
                                        <p className="form-helper-text">
                                            Whole paid days granted at the start of each year.
                                        </p>
                                    </FormGroup>
                                </Col>
                                <Col md={6}>
                                    <FormGroup>
                                        <ControlLabel>
                                            Annual Vacation Leave
                                            <span className="required-star">*</span>
                                        </ControlLabel>
                                        <FormControl
                                            type="number"
                                            name="vacationLeaveDays"
                                            value={vacationLeaveDays}
                                            onChange={this.handleFormChange}
                                            min="0"
                                            step="1"
                                        />
                                        <p className="form-helper-text">
                                            Whole paid days granted at the start of each year.
                                        </p>
                                    </FormGroup>
                                </Col>
                            </Row>
                            {error &&
                                <Alert bsStyle="danger">
                                    {error}
                                </Alert>
                            }
                            <Button bsStyle="primary" pullRight fill onClick={this.save}>
                                {isNewRecord ? "Create" : "Save changes"}
                            </Button>
                            <div className="clearfix" />
                        </form>
                        }
                    />
                </Col>
            </Row>
        )
    }
}

export default PayLevelForm
